import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./home-page.css";
import logo from "./logo-quadrato.png";
import { Icons } from "./icons";
import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";
import MarketingFooter from "./components/MarketingFooter";
import QiraHomeChat from "./components/QiraHomeChat";

export default function Home() {
  const navigate = useNavigate();
useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { threshold: 0.12 }
  );

  document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}, []);

  return (
    <div className="home-pro">
      <SEO
        title="QrMenu Italia | Menu QR, Ordini, Cucina, Sala e Asporto"
        description="QrMenu Italia è un sistema modulare per locali: menu digitale senza app e senza registrazione, ordini dal tavolo facoltativi, cucina, sala, stampa comande, asporto con OTP e intelligenza artificiale."
        canonical="https://qrmenu-italia.it/"
        image="https://qrmenu-italia.it/og-home-v2.jpg"
        keywords="menu qr, menu digitale, menu qr ristorante, menu qr pizzeria, ordini dal tavolo, asporto con otp, stampa comande, intelligenza artificiale ristoranti, qrmenu"
      />

      <MarketingNavbar />

      {/* HERO */}
      <section className="hp-hero">
        <div className="hp-hero-noise" />
        <div className="hp-hero-glow" />

        <div className="hp-hero-inner">
        <div className="hp-hero-eyebrow">
  <span className="hp-dot" />
  Menu QR • Ordini • Cucina • Sala • Intelligenza Artificiale
</div>

          <h1 className="hp-hero-h1">
  L'Intelligenza Artificiale
  <span className="hp-hero-accent">
    che rende il tuo menu molto più di un menu QR.
  </span>
</h1>

<p className="hp-hero-sub">
  L'Intelligenza Artificiale aiuta i clienti a scegliere piatti, abbinamenti e prodotti aggiuntivi,
  supporta la sala durante il servizio e permette al gestore di creare contenuti e traduzioni in pochi secondi.
  Tutto integrato con menu digitale, cucina, asporto e giochi, senza cambiare il tuo modo di lavorare.
</p>

          <div className="hp-hero-pills">
            <span className="hp-pill">✦ AI che aiuta il cliente a scegliere</span>

<span className="hp-pill">✦ AI per sala e camerieri</span>

<span className="hp-pill">✦ AI per traduzioni e contenuti</span>
            <span className="hp-pill">✦ Camerieri avvisati su ordini e richieste</span>
            <span className="hp-pill">✦ Asporto con codice OTP</span>
            <span className="hp-pill">✦ Piani a partire da 0€/mese</span>
          </div>

          <div className="hp-hero-actions">
            <button
              className="hp-btn-demo"
              onClick={() => navigate("/demo")}
            >
              Prova Gratis 7 Giorni
              <span className="hp-btn-arrow">→</span>
            </button>

            <button
              className="hp-btn-primary"
              onClick={() => navigate("/contatti")}
            >
              Richiedi informazioni
            </button>

            <a href="#funzioni" className="hp-btn-ghost">
              Capisci in 30 secondi
            </a>
          </div>
        </div>

        <div className="hp-hero-mockup">
          <div className="hp-phone">
            <div className="hp-phone-notch" />

            <div className="hp-phone-screen">
              <div className="hp-screen-header">
                <div className="hp-screen-tag">Tavolo 8</div>
                <div className="hp-screen-time">20:42</div>
              </div>

              <div className="hp-screen-category active">Pizze</div>
              <div className="hp-screen-category">Antipasti</div>
              <div className="hp-screen-category">Bevande</div>

              <div className="hp-screen-item">
                <div className="hp-screen-item-img" />
                <div className="hp-screen-item-info">
                  <div className="hp-screen-item-name">Pizza Margherita</div>
                  <div className="hp-screen-item-price">€ 8,50</div>
                </div>
                <div className="hp-screen-item-add">+</div>
              </div>

              <div className="hp-screen-item">
                <div className="hp-screen-item-img alt" />
                <div className="hp-screen-item-info">
                  <div className="hp-screen-item-name">Birra artigianale</div>
                  <div className="hp-screen-item-price">€ 5,00</div>
                </div>
                <div className="hp-screen-item-add">+</div>
              </div>

              <div className="hp-screen-ai">
                <span className="hp-screen-ai-dot" />
                Ordine inviato in cucina • sala avvisata
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COSA FA */}
      <section className="hp-pillars reveal" id="funzioni">
        <div className="hp-pillars-inner">
          <div className="hp-section-tag">In pratica</div>

          <h2 className="hp-section-h2">
            Come QrMenu può migliorare il tuo locale
          </h2>

          <div className="hp-pillars-grid">
            <div className="hp-pillar-card">
  <div className="hp-pillar-icon">
    {Icons.qr ? Icons.qr({ size: 28, color: "#ffd600" }) : null}
  </div>
  <h3>Menu digitale QR</h3>
<p>
  Modifichi piatti, prezzi, allergeni, foto e descrizioni in pochi secondi.
  I clienti trovano sempre il menu corretto dal telefono,
  senza app e senza registrazione.
</p>
</div>

<div className="hp-pillar-card">
  <div className="hp-pillar-icon">
    {Icons.ordini ? Icons.ordini({ size: 28, color: "#ff6b35" }) : null}
  </div>
  <h3>Ordini dal tavolo</h3>
<p>
  Li attivi solo se vuoi. Ricevi ordini chiari e leggibili,
  riduci errori di comanda e velocizzi il passaggio delle informazioni
  tra tavolo, sala e cucina.
</p>
</div>

<div className="hp-pillar-card">
  <div className="hp-pillar-icon">
    {Icons.cucina ? Icons.cucina({ size: 28, color: "#a78bfa" }) : null}
  </div>
  <h3>Cucina e stampa comande</h3>
<p>
  La cucina riceve comande chiare e ordinate, senza passaggi a voce
  o fogli poco leggibili. Se vuoi, QrPrint le stampa automaticamente
  appena arriva un nuovo ordine.
</p>
</div>

<div className="hp-pillar-card hp-pillar-card--featured">
  <div className="hp-pillar-icon">
    {Icons.table ? Icons.table({ size: 28, color: "#38bdf8" }) : null}
  </div>
  <h3>Sala, camerieri e giochi</h3>
<p>
  Il personale riceve notifiche e richieste dal tavolo in tempo reale,
  mentre i giochi accessibili dal QR rendono più piacevole l'attesa
  e contribuiscono a migliorare l'esperienza del cliente.
</p>
</div>

<div className="hp-pillar-card">
  <div className="hp-pillar-icon">
    {Icons.ordini ? Icons.ordini({ size: 28, color: "#00d4aa" }) : null}
  </div>
  <h3>Asporto con OTP</h3>
 <p>
  Ricevi ordini da asporto verificati tramite codice OTP,
  riducendo ordini fantasma, errori sul ritiro e confusione
  nella gestione delle prenotazioni.
</p>
</div>

<div className="hp-pillar-card">
  <div className="hp-pillar-icon">
    {Icons.ai ? Icons.ai({ size: 28, color: "#00d4aa" }) : null}
  </div>
  <h3>Intelligenza artificiale</h3>
  <p>
    Accompagna il cliente nella scelta dei piatti, suggerisce abbinamenti
    e prodotti aggiuntivi, supporta la sala durante il servizio e permette
    al gestore di creare descrizioni, traduzioni e contenuti in pochi secondi.
  </p>
</div>
          </div>
        </div>
      </section>

      {/* NON DEVI ATTIVARE TUTTO */}
      <section className="hp-modular reveal">
        <div className="hp-modular-inner">
          <div className="hp-section-tag">La cosa più importante</div>

          <h2 className="hp-section-h2">
            Non devi attivare tutto: scegli tu come usare QrMenu
          </h2>

<p className="hp-modular-lead">
  Parti dal semplice menu digitale e aggiungi solo le funzioni
  che possono farti risparmiare tempo, ridurre errori
  e migliorare il servizio del tuo locale.
</p>

          <div className="hp-modular-grid">
            <div className="hp-modular-card">
              <h3>Solo menu digitale</h3>
              <p>
  Il modo più semplice per iniziare: mostri sempre prezzi,
  piatti e allergeni corretti, senza attivare ordini o altre funzioni.
</p>
            </div>

            <div className="hp-modular-card">
              <h3>Menu + ordini + cucina</h3>
              <p>
                Attivi gli ordini dal tavolo e li fai arrivare in cucina,
                con stampa automatica delle comande se configurata.
              </p>
            </div>

            <div className="hp-modular-card">
              <h3>Menu + sala</h3>
              <p>
                Il personale può ricevere notifiche per ordini pronti,
                chiamate di servizio e richieste dal tavolo.
              </p>
            </div>

            <div className="hp-modular-card">
  <h3>Sistema completo</h3>
  <p>
    Unisci menu digitale, cucina, sala, asporto con OTP, giochi
    e Intelligenza Artificiale in un'unica piattaforma pensata
    per migliorare il lavoro del locale.
  </p>
</div>
          </div>

          <div className="hp-modular-callout">
            <strong>QrMenu si adatta al tuo locale, non il contrario.</strong>
            {" "}Puoi usarlo in modo semplice o completo, in base alle tue esigenze.
          </div>
        </div>
      </section>

      {/* CLIENTE VS LOCALE */}
      <section className="hp-difference reveal">
        <div className="hp-difference-inner">
          <div className="hp-section-tag">Due punti di vista</div>

          <h2 className="hp-section-h2">
  Più semplice per il cliente, più controllo per il locale
</h2>

          <div className="hp-difference-grid">
            <div className="hp-difference-card hp-difference-card--muted">
              <h3>Il cliente</h3>
              <ul>
  <li>Vede subito il menu, senza scaricare app</li>
  <li>Consulta foto, allergeni e descrizioni in chiaro</li>
  <li>Ordina dal tavolo quando vuole, se attivo</li>
  <li>Non deve aspettare il cameriere per essere ascoltato</li>
  <li>Ritira l'asporto senza fraintendimenti, con OTP</li>
</ul>
            </div>

            <div className="hp-difference-card hp-difference-card--accent">
              <h3>Il locale</h3>
              <ul>
                <li>Aggiorna menu, prezzi e allergeni senza ristampe</li>
                <li>Decide quali funzioni attivare</li>
                <li>Può inviare gli ordini in cucina</li>
                <li>Può avvisare sala e camerieri</li>
                <li>Sfrutta l'Intelligenza Artificiale per migliorare servizio e gestione</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* FLUSSO */}
      <section className="hp-how reveal" id="come-funziona">
        <div className="hp-how-inner">
          <div className="hp-section-tag">Come funziona</div>

          <h2 className="hp-section-h2">
            Il flusso è semplice
          </h2>

          <div className="hp-how-steps">
            <div className="hp-how-step">
              <div className="hp-how-num">01</div>
              <div className="hp-how-text">
                <strong>Il cliente scansiona il QR</strong> e apre il menu dal telefono,
                senza app e senza registrazione.
              </div>
            </div>

            <div className="hp-how-connector" />

            <div className="hp-how-step">
              <div className="hp-how-num">02</div>
              <div className="hp-how-text">
                <strong>Consulta il menu</strong> con foto, allergeni, descrizioni,
                traduzioni e suggerimenti se attivi.
              </div>
            </div>

            <div className="hp-how-connector" />

            <div className="hp-how-step">
              <div className="hp-how-num">03</div>
              <div className="hp-how-text">
                <strong>Ordina solo se lo permetti tu</strong>. In alternativa
                il cameriere resta al centro del servizio.
              </div>
            </div>

            <div className="hp-how-connector" />

            <div className="hp-how-step">
              <div className="hp-how-num">04</div>
              <div className="hp-how-text">
  <strong>Tu mantieni il controllo del servizio</strong>, con ordini chiari,
  notifiche alla sala e stampa automatica se configurata.
</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="hp-final reveal">
        <div className="hp-final-noise" />
        <div className="hp-final-inner">
<h2 className="hp-final-h2">
  Scopri come l'Intelligenza Artificiale può fare la differenza nel tuo locale.
</h2>

<p className="hp-final-sub">
  Menu digitale, cucina, sala, asporto e Intelligenza Artificiale
  in un'unica piattaforma. Provalo gratuitamente e attiva solo
  le funzioni che ti servono davvero.
</p>

          <button
            className="hp-btn-primary hp-btn-xl"
            onClick={() => navigate("/demo")}
          >
            Prova Gratis 7 Giorni
            <span className="hp-btn-arrow">→</span>
          </button>
        </div>
      </section>

      <MarketingFooter />

      <QiraHomeChat />
    </div>
  );
}